__webpack_require__.p = "/react-rock-paper-scissors/";